import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useMsal } from '@azure/msal-react';

import {
  Tooltip,
  IconButton,
  Menu,
  MenuItem,
  MenuList,
  Avatar,
  ListItemIcon,
  Divider,
  Typography,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';

import { useProfileDrawers } from 'hooks/useProfileDrawers';

export const AuthAvatarMenu = () => {
  const { instance } = useMsal();

  const { openDrawerProfileDetails } = useProfileDrawers();

  const currentUser = useSelector((state) => state.auth.currentUser);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = async () => {
    console.log('Logout');
    instance.logoutRedirect();
  };

  return (
    <>
      <Tooltip
        title="Profile"
        placement="bottom"
        arrow
      >
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <Avatar sx={{ width: 32, height: 32, fontSize: 15 }}>
            {currentUser?.name
              ?.split(' ')
              .slice(0, 2)
              .map((word) => word.charAt(0).toUpperCase())
              .join('')}
          </Avatar>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuList sx={{ minWidth: '200px', p: 0 }}>
          <MenuItem
            dense
            disableRipple
            sx={{
              cursor: 'default',
              pointerEvents: 'none',
              maxWidth: 240,
              display: 'flex',
            }}
          >
            <ListItemIcon sx={{ color: (theme) => theme.palette.grey[750] }}>
              <Avatar sx={{ width: 26, height: 26, fontSize: 13 }}>
                {currentUser?.name
                  ?.split(' ')
                  .slice(0, 2)
                  .map((word) => word.charAt(0).toUpperCase())
                  .join('')}
              </Avatar>
            </ListItemIcon>
            <Typography
              variant="body2"
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: 180,
              }}
            >
              Hi, {currentUser?.name || ''}!
            </Typography>
          </MenuItem>
          <Divider />
          <MenuItem
            dense
            onClick={() => openDrawerProfileDetails()}
          >
            <ListItemIcon sx={{ color: (theme) => theme.palette.grey[750] }}>
              <Person2OutlinedIcon fontSize="small" />
            </ListItemIcon>
            View Profile
          </MenuItem>
          <MenuItem
            dense
            onClick={handleLogout}
          >
            <ListItemIcon sx={{ color: (theme) => theme.palette.grey[750] }}>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            Sign Out
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  );
};
